import React, { useEffect, useState } from "react";
import {
  Dialog, DialogActions, DialogContent, Button, Typography, Box,
  Card, CardContent, Grid, Divider
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ReceiptIcon from "@mui/icons-material/Receipt";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import api from "../../api";

// Helper: Format ISO date to dd/mm/yyyy
const formatDate = (isoDate) => {
  if (!isoDate) return "No disponible";
  const date = new Date(isoDate);
  return date.toLocaleDateString("es-ES", {
    day: "2-digit", month: "2-digit", year: "numeric"
  });
};

const DetalleMantenimiento = ({ selectedMantenimiento, handleDetailClose }) => {
  const [mantenimiento, setMantenimiento] = useState(null);

  useEffect(() => {
    if (selectedMantenimiento) {
      api.get(`mantenimiento/${selectedMantenimiento.id}/`)
        .then((response) => setMantenimiento(response.data))
        .catch(() => alert("Error al cargar detalles del mantenimiento."));
    }
  }, [selectedMantenimiento]);

  return (
    <Dialog open={!!selectedMantenimiento} onClose={handleDetailClose} fullWidth maxWidth="md">
      <DialogContent dividers sx={{ padding: 3, backgroundColor: "#f4f6f9" }}>
        {mantenimiento ? (
          <Card sx={{ boxShadow: 3, borderRadius: "8px", padding: 2 }}>
            {/* Header */}
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#152d51",
                display: "flex",
                alignItems: "center",
                marginBottom: 2
              }}
            >
              <CalendarTodayIcon sx={{ marginRight: 1, color: "#152d51" }} />
              <strong>Detalles del Mantenimiento</strong>
            </Typography>

            <Divider sx={{ my: 2 }} />

            <CardContent>
              <Grid container spacing={2}>
                {/* Left Column */}
                <Grid item xs={12} sm={6}>
                  <InfoItem icon="&nbsp;&nbsp;-" label="Solicitud" value={mantenimiento.solicitud} />
                  <InfoItem icon="&nbsp;&nbsp;-" label="Fecha de Requerimiento" value={formatDate(mantenimiento.fecha_requerimiento)} />
                  <InfoItem icon="&nbsp;&nbsp;-" label="Respuesta CCOO" value={mantenimiento.rta_ccoo} />
                  <InfoItem icon="&nbsp;&nbsp;-" label="Estado de Reparación" value={mantenimiento.estado_reparacion} />
                  <InfoItem icon="&nbsp;&nbsp;-" label="Fecha de Ingreso" value={formatDate(mantenimiento.fecha_ingreso)} />
                  <InfoItem icon="&nbsp;&nbsp;-" label="Fecha de Egreso" value={formatDate(mantenimiento.fecha_egreso)} />
                  <InfoItem icon="&nbsp;&nbsp;-" label="¿Abonado?" value={mantenimiento.abonado ? "Sí" : "No"} />
                </Grid>

                {/* Right Column */}
                <Grid item xs={12} sm={6}>
                  <InfoItem icon="&nbsp;&nbsp;-" label="Nro Factura" value={mantenimiento.nro_factura} />
                  <InfoItem icon="&nbsp;&nbsp;-" label="Tramix Nro" value={mantenimiento.tramix_nro} />
                  <InfoItem icon="&nbsp;&nbsp;-" label="Ficha Técnica" value={mantenimiento.cargado_en_ficha_tec ? "Sí" : "No"} />
                  <InfoItem icon="&nbsp;&nbsp;-" label="Descripción" value={mantenimiento.descripcion} />
                  <InfoItem icon="&nbsp;&nbsp;-" label="Monto" value={mantenimiento.monto ? `$${mantenimiento.monto}` : "No especificado"} />
                  <InfoItem icon="&nbsp;&nbsp;-" label="Taller / Mecánico" value={mantenimiento.taller || "No asignado"} />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        ) : (
          <Typography variant="body2" color="textSecondary">
            No se encontraron detalles del mantenimiento.
          </Typography>
        )}
      </DialogContent>

      <DialogActions sx={{ padding: "16px", backgroundColor: "#f4f6f9" }}>
        <Button onClick={handleDetailClose} variant="contained" sx={{ backgroundColor: "#152d51" }} fullWidth>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// Detail Row Component
const InfoItem = ({ icon, label, value }) => (
  <Box sx={{
    display: "flex",
    alignItems: "center",
    marginBottom: 1,
    backgroundColor: "#f4f6f9",
    padding: 1.5,
    borderRadius: "8px"
  }}>
    {icon && <Box sx={{ marginRight: 1, color: "#152d51" }}>{icon}</Box>}
    <Typography variant="subtitle1">
      <strong>{label}:</strong> {value || "No disponible"}
    </Typography>
  </Box>
);

export default DetalleMantenimiento;


